import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class ForInvestorsLinkedItem extends ContentItem {
  constructor() {
    super({
        opertyResolver: fieldName => `_${fieldName}`
    });
  }
  get type() {
    return get(this, 'file_type.value[0].codename', '');
  }
  get description() {
    return get(this, 'description.value', '');
  }
  get date() {
    return get(this, 'date.value', '');
  }
  get url() {
    return get(this, 'linked_asset.value[0].url', '');
  }

}



// WEBPACK FOOTER //
// ./src/models/ForInvestorsLinkedItem.model.js